import styled, { css } from 'styled-components'

export const BadgeNotifications = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1rem;
    margin-left: 0.25rem;
    padding: 0.25rem;
    min-width: 1rem;
    max-width: 3rem;

    border-radius: 2rem;
    line-height: 1rem;
    font-size: var(--sl-font-size-1);
    font-weight: 500;

    background: var(--sl-bg-critical-strong);
    color: ${theme.colors.white};
  `}
`
